import type { StateTree } from '@makemydeal/dr-dash-types';

export const getReferenceRateType = (state: StateTree): string => {
    return state.rateType.referenceRateType || '';
};
